import { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';

type Position = 'top' | 'bottom' | 'left' | 'right'

type ToolTipProps = {
  text: string,
  position: Position,
  children: ReactNode
}

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;


const TooltipContent = styled.div<{ $isVisible: boolean, $position: Position}>`
  position: absolute;
  ${({ $position }) => {
    switch ($position) {
      case 'top':
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'bottom':
        return `
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'left':
        return `
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
        `;
      case 'right':
        return `
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
        `;
      default:
        return '';
    }
  }}
  background-color: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 10;
`;

const Tooltip: FC<ToolTipProps> = ({ text, position = 'top', children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TooltipContainer
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      <TooltipContent $isVisible={isVisible} $position={position}>
        {text}
      </TooltipContent>
    </TooltipContainer>
  );
};

export default Tooltip;